
<template lang="pug">
    include /@ibkr/lib.common/src/icon/basic
    ib-col(class="fin-explorer flex")
        ib-row
            ib-col(v-if="status === 'selection'")
                SearchByType
            ib-col(v-if="status === 'selection' && selectedTab === 'filters'")
                div()
                    RegionTypes
                    AssetSelector(
                        :class="{'insetx-8': $media.l, 'insetx-4': !$media.l}",
                    )
                    IndustryType(
                        :class="{'insetx-8': $media.l, 'insetx-4': !$media.l}",
                    )
                    MarketRange(
                        :class="{'insetx-8': $media.l, 'insetx-4': !$media.l}",
                        v-if="selectedAssets.includes('stocks')",
                    )
                    CurrencySelector(
                        :class="{'start-16': $media.l, 'insetx-4': !$media.l}",
                        ref="currencyType"
                    )
            ib-col(v-if="status === 'selection' && selectedTab === 'companies'")
                div(class="border-bottom")
                    SelectGroups(ref="selectGroups")
                    ib-col
                        CurrencySelector(
                            :class="{ 'currency-selector': !$media.xl, 'extra-pad': $media.xl, 'insetx-8': $media.m, 'insetx-4': !$media.m }",
                            ref="comCurType"
                        )
            div(
                class="text-left insety-16",
                :class="{'insetx-4': !$media.l, 'inset-16': $media.l}"
                v-if="status === 'selection'"
            )
                span(v-if="$media.xl || $media.l")
                    ib-button(
                        class="inversed-black",
                        @click="getResults",
                        tone="accent",
                        :disabled="!canSubmit",
                        :busy="loadingResult",
                    ) {{ $t('view_results') }}
                    ib-button(
                        @click="resetFilters",
                        class="fg-primary inversed",
                        tone="border-accent",
                    ) {{ $t('reset_filter') }}
                span(v-else)
                    ib-button(
                        class="inversed-black text-center",
                        @click="getResults",
                        tone="accent",
                        :disabled="!canSubmit",
                        :busy="loadingResult",
                        width="100%"
                    ) {{ $t('view_results') }}
                    ib-button(
                        @click="resetFilters",
                        class="fg-primary inversed text-center",
                        tone="border-accent",
                        width="100%"
                    ) {{ $t('reset_filter') }}

            NewSearchResults(v-if="status === 'results' || status === 'loading'")

        ib-dialog(v-model="showModal", autoclose=true, id="ns-dialog")
            h3(class="inset-16 text-center", v-if="$media.l") {{ $t('service_not_available') }}
                span(class="insetx-8" @click="showModal = false")
                    +icon-basic-cancel
            p(class="inset-16 fs5 text-left", v-else) {{ $t('service_not_available') }}            
</template>
<script>
    import { mapState, mapActions, mapGetters } from 'vuex';
    
    import api from '../api/';
    import SearchByType from './SearchByType.vue';
    import IndustryType from './IndustryType.vue';
    import RegionTypes from './RegionTypes.vue';
    import MarketRange from './MarketRange.vue';
    import AssetSelector from './AssetSelector.vue';
    import SelectGroups from './SelectGroups.vue';
    import CurrencySelector from './CurrencySelector.vue';
    import NewSearchResults from './NewSearchResults.vue';

    export default {
        name: 'FinExplorer',
        components: {
            SearchByType,
            IndustryType,
            RegionTypes,
            MarketRange,
            AssetSelector,
            SelectGroups,
            CurrencySelector,
            NewSearchResults,
        },
        data() {
            return {
                showModal: false,
                resultsResponse: {},
                averagesResponse: {},
                loadingResult: false,
            }
        },
        methods: {
            // Needed b/c we don't want the user to go to the results page with 0 results.
            getResults() {
                const skipAvg = false;;
                const firstCall = true;
                this.loadingResult = true;
                this.search({skipAvg, firstCall})
                    .then(data => {
                        this.loadingResult = false;
                        this.setStatus('results');
                    })
                    .catch(error => {
                        console.error(error);
                        $alert(this.$t('zero_results'), {tone: 'remove'});
                        this.loadingResult = false;
                    });
            },
            resetFilters() {
                console.debug('Reset Filters called');
                this.reset();
            },
            ...mapActions(['setStatus', 'setRegions', 'setCurrentPage', 'setSorting', 'reset', 'rollbackAssets', 'setIds', 'search'])
        },
        computed: {
            canSubmit: function() {
                if (this.status !== 'selection') return false;
                
                if (this.selectedTab === 'filters') {
                    if (this.selectedRegions.length === 0) return false;
                    if (this.selectedAssets.length === 0) return false;
                    if (this.selectedSectors.length === 0) return false;
                    if (this.selectedAssets.includes('stocks') && this.selectedMarketCaps.length === 0) return false;
                }
                else if (this.selectedTab === 'companies') {
                    if (this.groups.length === 0) return false;
                    const numSelectedOfAllGroups = [...[].concat(...this.groups.map(group => group.companies))].filter(comp => comp.selected).length;
                    if (numSelectedOfAllGroups <= 0) return false; 
                }
                else {
                    return false;
                }

                if (this.selectedCurrency === '')  return false;
                return true;
            },
            ...mapGetters(['selectedRegions', 'selectedAssets', 'selectedSectors', 'selectedMarketCaps']),
            ...mapState(['groups', 'status', 'selectedTab', 'selectedCurrency', 'regions', 'sectors', 'currencyConversions','currentPage', 'sort', 'marketCaps', 'marketDataPrices', 'ids', 'averages', 'listedResults']),
        },
        watch: {
            status: {
                handler: function(val) {
                    const v = val === 'results' || val === 'loading';
                    // Hide instructions from en/trading/globalanalyst.php
                    const fi = document.getElementById("finexplorer-instruct");
                    if (!fi) return;
                    if (v === true) {
                        fi.style.display = "none";
                    } else {
                        fi.style.display = "block";
                    }
                    // Hide data delay dislosure if showResults equals true
                    const dataDelay = document.querySelector("p.data-delay");
                    if (!dataDelay) return;
                    if (v === true) {
                        dataDelay.style.display = "block";
                    } else {
                        dataDelay.style.display = "none";
                    }
                }
            },
        },
        mounted() {
            api.checkService()
                .catch(error => this.showModal = true)
        }
    }
</script>
<style lang="less">
    .fin-explorer {
        .active {
            background-color:#ccebda !important;
        }
        p {
            font-size: 1rem;
            &.currency-title {
                display: inline-flex;
                width: 17.666667% !important;
            }
        }
        .currency-selector {
            display: block;
        }
        /*fin-table */
        .fin-table {
            ._tb {
                th {
                    padding: 0;
                    div {
                        padding: 6px 8px;
                    }
                }
            }
        }
    }

    ._tb th > ._thc {
        width: 100%;
    }

    /*end fin-table */

    .fin-explorer {
        ._btn {
            &&._active {
                &&::after {
                    background-color: rgba(0,0,0,0);
                    opacity: 0;
                }
            }
            &:active {
                &:hover {
                    &::after {
                        background-color: rgba(0,0,0,0);
                        opacity: 0;
                    }
                }
            }
        }
        button {
            border-radius: 0;
            font-size: 0.8125rem;
            background-color: #fcfcfc;
            svg {
                width: 1em;
                height: 1em;
                vertical-align: sub;
            }
            &:hover {
                background-color: white;
            }
            &::after {
                background-color: white;
                opacity: 0;
            }  
        }
    }
    .padding-zero {
        /* Had to use important to override styling */
        padding-right: 0 !important;
        padding-left: 0 !important;
        padding-top: 0 !important;
        padding-bottom: 0 !important;
    }
    .info {
        //position: absolute;
        &:hover {
            .tooltext {
                visibility: visible;
            }
        }
        &.results {
            display: block;
            text-align: center;
            svg {
                fill:#0b56bf;
                width: 0.9em;
                height: 0.9em;
                cursor: pointer;
                vertical-align: baseline;
            }
        }
        svg {
            fill:#0b56bf;
            width: 0.9em;
            height: 0.9em;
            cursor: pointer;
            vertical-align: baseline;
        }
        .tooltext {
            visibility: hidden;
            width: 200px;
            background-color: black;
            color: #fff;
            text-align: center;
            padding: 5px 0;
            border-radius: 6px;
            position: absolute;
            z-index: 1;
        }
    }
    .inversed {
        &.fg-primary {
            font-size: 16px;
        }
        &:hover {
            border-color: #000;
            color: #000;
        }
    }
    .inversed-black {
        &.accent {
            font-size: 16px;
        }
        &:hover {
            background-color: #0b56bf !important;
        }
    }
    .disclosures {
        p {
        max-width: 1140px;
        }
    }
    #ns-dialog {
        width: 50%;
        max-width: 700px;
        h3 {
            width: 100%;
        }
    }
    .inner {
        width: 100%;
        border-top: 0.25rem solid #db1222;
        .modal-body {
            padding: 20px 30px;
        }
    }
    .inner-modal {
        width: 100%;
        border-top: 0.25rem solid #db1222;
        h5 {
            margin-top: 20px;
            margin-bottom: 5px;
            font-weight: 300;
        }
        .act {
            background: #db1222;
            border-radius: 0;
            padding: 0.375rem 0.75rem;
        }
        .add-info {
            border-bottom: 1px solid #d7d7d7;
            padding: 20px 30px;
            svg {
                width: 24px;
                height: 24px;
            }
            h3 {
                display: inline-block;
                font-weight: 300;
            }
            a {
                top: 10px;
                right: 15px;
                position: absolute;
                font-size: 1.5rem;
            }
        }
        .modal-body {
            padding: 20px 30px;
        }
    }
    @media (max-width: 1000px) and (orientation: landscape) {
        .info-dialog {
            height: 100%;
            width: 800px;
        }
    }
    @media (max-width: 700px) and (orientation: landscape) {
        .info-dialog {
            max-height: 98%;
            max-width: 98%;
            .inner {
                .modal-header {
                    padding: 2px 10px !important;
                    h3 {
                        font-size: 1rem;
                    }
                }
                .modal-body {
                    padding: 2px 30px;
                }
            }
        }
    }
     
    @media (max-width: 600px) {
        .header {
            h1 {
                font-size: 1.6em;
            }
        }
        .inversed-black {
            &.accent {
                margin-right: 0;
                margin-left: 0;
                text-align: left;
            }
        }
        .inversed {
            &.fg-primary {
                margin-right: 0;
                margin-left: 0;
                text-align: left;
            }
        }
        #ns-dialog {
            width: 90%;
        }
        .inner-modal {
            .add-info {
                padding: 20px 40px 10px 15px;
            }
            .act {
                margin: 10px 0 0 0;
                width: 100%;
            }
            .modal-body {
                padding: 25px 15px;
            }
        }
    }
</style>
